export default __webpack_public_path__ + "static/media/ic_twitter-1.1583182d.svg";